import { BaseRequestsService } from '@/services/base-requests-service';

class ProfileManageRequests extends BaseRequestsService {

  getUserData() {
    return this.http.get('v1/users/details');
  }

  // Password or language updating api
  updateUserInfo(options) {
    return this.http.put('v1/users/info', options);
  }

  updateUserDetails(options) {
    return this.http.put('v1/users/detail', options);
  }

}

const profileManageRequests = new ProfileManageRequests();
export { profileManageRequests as ProfileManageRequests };
